(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9759],{

/***/ 30797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/poshmark-photo-editing-apps/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-01-22",
      tag: "Crosslisting",
      title: "The 8 Best Photo Editing Apps for Poshmark",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Poshmark app is a social marketplace with more than 80 million registered users. It is one of the best and favorite apps for reselling clothes, jeans, accessories, shoes, and home decors. Poshmark limits the number of photos per listings and draft listings, so it is important that your images catch the limited attention of your buyers to improve your Poshmark business' visibility and sales.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Many of us want our Poshmark business to get more views, get lots of shares, and generate sales. However, not everyone has the skills or money to hire a professional photographer for their Poshmark photos. The good thing is, there are a lot of free photo editing apps for new Poshmark sellers to choose from.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["We've done the research and compiled a list of some of the most popular photo apps you can use to elevate your Poshmark closet! As well as some tips and tricks on how to improve photos taken from the regular camera of your mobile device. Here is an overview of eight of the most popular photo editing apps for Poshmark that can help you get your closet looking great in no time!", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "1. Canva - Free, Canva Pro $12.99/mo "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Canva is one of the leading photo editing apps, with more than 55 million monthly active users worldwide. Canva offers free photo tools for basic editing and enhancement that help your clothes and accessories pop. They also have Canva pro, which is the premium version of Canva, that gives you access to all the photo editing tools you can use to enhance your Poshmark closet further.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers free basic photo editing tools "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Easy to use and user-friendly "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers a wide variety of templates with correct sizing for most social media platforms"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Customizable templates "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It contains free stock photos"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Export limitations, cannot export to files like PDF"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "\"Raw\" files are not downloadable"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The free account offers limited access to templates and photo editing tools."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Everything you made inside Canva is their property, not yours. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "2. Photoscape X - Free, Photoscape Pro $39.99 "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Photoscape lets you easily edit images taken from your iPhone and other smartphone cameras. They have an easy-to-use app with comprehensive features for editing and enhancing photos, perfect for your soon-to-be-listed items on Poshmark. It also has video tutorials that walk you through each photo editing function. This online photo editing app is available to download on the Apple app store and play store.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Simple to use interface "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "A wide array of editing and effects tools "
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Offers free basic enhancement tools for color adjustment, cutting, resizing, printing, and GIFs animation.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It has a reliable \"undo\" function for retouching photos"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You can easily convert raw images into JPEG images"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["It has a batch edition function that allows you to rename, convert, or resize multiple images simultaneously.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The alignment of their auto-adjustment features isn't precise. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Functions are not easy to locate. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Not very accurate in removing the background of a photo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lacks of templates and collages for the free version "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "3. GIMP (GNU Image Manipulation Program) - Free"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["GIMP is one of the best free and open-source online photo editing software. Although this photo editor is not as beginner-friendly as others on this list, you can start enhancing photos for your Poshmark closet once you get the hang of it. GIMP also continuously innovates and updates, adding new features and functions that offer great value for beginners and small business owners.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It has all the essential features and tools for photo editing and enhancement. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It lets you create GIFs using many layers "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Allows you to edit and export photos of various formats"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It has an intuitive interface"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Easy image manipulation "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lack of customer support "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Resizing and cropping can be challenging to use "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Slow Download time for large files"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It does not support RAW files "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Limited options for developing 3D Designs"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "4. BeFunky - Free, BeFunky Plus $9.99/mo"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This photo editor brings the creative side to your Poshmark business. BeFunky lets you play with hundreds of photo effects such as Cartoonizer, oil painting, and digital art effects. They also offer features and tools that allow you to customize graphics, frames, overlays, and texture.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["You can also add text to your photos with a wide array of fonts to choose from. Also, it has all the essential on-the-go edits for your Poshmark images with an intuitive photo editing interface that makes your photos stand out even more.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Easily edit your photos and make a photo collage"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Crop and resize your pictures with pixel-perfect accuracy "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "You can edit images in batch "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers AI (Artificial Intelligence) background remover with a single click "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers a wide selection of customizable design templates "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Slow response time from customer support "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers limited template for the Free version"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Provides fewer features for the Free plan"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It does not have a wide variety of filters to edit images. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "5. PicMonkey - $7.99-$23/mo"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This photo editing tool is popular because of its beginner-friendly interface and tools. You can easily edit and enhance your new and used clothes, shoes, accessories and get stunning results. This photo editor also offers auto options (autocorrect, auto adjust, etc.) for quick, smooth, and on-the-go photo editing on mobile devices."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Easy to learn tools and user-friendly app "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Constantly improving and adding new content keeping your Poshmark business organized and trendy. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers modern and sleek designs "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Large selection of fonts available to use"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Easy photo editing, cropping, and resizing from photos taken from smartphone cameras."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Unlike other photo editing apps, they do not offer any tutorials/instructions for newly added features", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Does not offer options to resize for social media platforms (i.e., Facebook banner) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Sizing tools and pixels are hard to understand and apply "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It does not offer video editing"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Does not offer GIFs animation"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "6. PhotoRoom - Free, PhotoRoom Pro $9.50/mo"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This photo editor is one of the most popular among Poshers in editing white backgrounds. PhotoRoom is a reliable photo editing app that lets you change the background of your Poshmark image for a clutter-free look. They also offer an easy-to-change background function that automatically removes the background of your item.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you do not have great lighting or great backgrounds at home, this app comes in handy. Simply place the item on a white background, and you can easily change the background using PhotoRoom. This app is downloadable on android and ios devices.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Creates studio-quality photos s in seconds"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers fast and smooth background remover function"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It uses artificial intelligence to cut out the background and present your subject automatically. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Provides a wide range of presets and templates"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Accept various photo formats "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Batch Export Mode (Pro Membership) lets you edit photos in batches. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It does not offer any manual eraser tools."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The free version sticks with a PhotoRoom watermark. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "7. VSCO cam - Free + In-App Purchase $19.99/year"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["This powerful photo editing app lets your Poshmark cover photo stand out. It offers a wide variety of preset filters to fine-tune every little detail of your Poshmark photos. They offer a free version with various simple yet elegant presets you can use to enhance your closet further. For Poshers wanting to elevate their closet, you can upgrade the app at an affordable price before finalizing your listings.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers subtle preset filters for your Poshmark photos"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers basic editing tools for color adjustment and exposure"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Simple and aesthetic designs "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Offers great looking web galleries for your photos "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Does not offer windows phone version"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Lacks social interaction features "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Only ten filters are included in the free version "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "8. Adobe Photoshop $20.99/mo"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Lastly, Adobe Photoshop remains the top and leading photo editing app of those serious about editing and enhancing their Poshmark photos. Unlike other photo editing apps, Photoshop offers a comprehensive photo editing tool for your Poshmark business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["But keep in mind that we wanted to enhance our items before posting them on our Poshmark account, not deceive others by changing colors or hiding any flaws using these photo editing apps.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Pros"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It offers tons of powerful and helpful photo editing tools"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Built-in social media templates"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Numerous filters, text, and styles to choose from "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Compatible with other Adobe Creative Cloud Apps"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Easy sharing to other social media platforms"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Cons "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "It takes a long time to learn, not beginner-friendly."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Expensive subscription cost "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Not ideal with regular PC users "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "In a Nutshell: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In this photo editor pros and cons guide, we've learned some of the best photo editing apps you can use to enhance your Poshmark cover photos. We suggest trying several editing apps and seeing which one works best for you. Others might be easy to use but lack social media templates, or others might take some time to learn. Try to explore your options first before paying for a monthly subscription. There are a lot of photo editing tools that offer a free trial before upgrading or trying out their premium versions. After all, we want to save time, get the worth of our money, and generate the results we want.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Also, keep in mind that your photo editing app should fix any photo flaws, color correction, or remove any unwanted elements on your photo. Avoid adding dramatic filters that can obscure what the item surely looks like. Only post the right color, size chart, and condition of the item you are selling to prevent unnecessary returns and problems from happening in the future.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["While choosing the best photo editor for your Poshmark business can be pretty overwhelming, it shouldn't compromise your day-to-day listing operation.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop is your trusted top sellers' choice for social marketplaces such as Poshmark, Depop, Mercari, eBay, and more. It is a marketing automation tool that saves you time from doing manual work with an online business. Now, you post good photos while getting more views, attracting more costumers, and generating more sales for your Poshmark business.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Visit ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/",
          children: "https://tools.oneshop.com/"
        }), " to learn more on how to avail of this exclusive all-in-one app."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/poshmark-photo-editing-apps.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "The 8 Best Photo Editing Apps for Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Poshmark limits the number of photos per listings, so catch the attention to grow your Poshmark sales!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/poshmark-photo-editing-apps"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/poshmark-photo-editing-apps"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "The 8 Best Photo Editing Apps for Poshmark"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Poshmark limits the number of photos per listings, so catch the attention to grow your Poshmark sales!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-01-22T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Crosslisting"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 13246:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/poshmark-photo-editing-apps",
      function () {
        return __webpack_require__(30797);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(13246); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);